/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import {Subject} from "rxjs/Subject";


export class LanguageSubscriber {
    id:string;
    subject: Subject<string>;
}